// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.valores {
  background: linear-gradient(135deg, #f8f9fa 0%, #fff5f0 100%);
}

.valores-grid {
  gap: 50px;
}

/* Texto introductorio */
.intro-text {
  margin-bottom: 60px;
  max-width: 900px;
  margin-left: auto;
  margin-right: auto;
}

.intro-text p {
  font-size: 1.05em;
  color: #555;
  line-height: 1.9;
  margin-bottom: 20px;
  text-align: justify;
}

.intro-text p:last-child {
  margin-bottom: 0;
}

.valor-card {
  position: relative;
  overflow: hidden;
  border-left: 6px solid #FF8C00;
  transition: all 0.5s cubic-bezier(0.23, 1, 0.320, 1);
  border-radius: 15px;
}

.valor-card::before {
  content: '';
  position: absolute;
  top: -100%;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(180deg, rgba(255, 140, 0, 0.08) 0%, transparent 100%);
  transition: top 0.6s ease;
  z-index: 0;
}

.valor-card:hover {
  border-left-color: #5B4B8A;
  transform: translateY(-20px) scale(1.04);
  box-shadow: 0 35px 70px rgba(91, 75, 138, 0.2);
}

.valor-card:hover::before {
  top: 0;
}

.card-icon {
  font-size: 3em;
  margin-bottom: 15px;
}

.valor-card h3 {
  position: relative;
  z-index: 1;
  font-size: 1.8em;
  color: #FF8C00;
  margin: 20px 0 15px 0;
  font-family: 'Playfair Display', serif;
  font-weight: 800;
  letter-spacing: 0.3px;
}

.valor-card p {
  position: relative;
  z-index: 1;
  color: #555;
  line-height: 1.9;
  font-size: 1em;
}

/* Sección: ¿Qué logras con nosotros? */
.beneficios-section {
  margin-top: 40px;
  padding: 35px 30px;
  background: linear-gradient(135deg, #FFF5E6 0%, #FFE8D6 100%);
  border-radius: 20px;
}

.beneficios-titulo {
  text-align: center;
  font-size: 1.8em;
  color: #333;
  margin-bottom: 30px;
  font-family: 'Playfair Display', serif;
  font-weight: 800;
  letter-spacing: 0.4px;
}

.beneficios-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 25px 20px;
}

.beneficio-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 10px;
  padding: 0;
  background: transparent;
  border-radius: 0;
  box-shadow: none;
  transition: all 0.3s ease;
}

.beneficio-item:hover {
  transform: none;
  box-shadow: none;
}

.beneficio-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  background: linear-gradient(135deg, #FF8C00 0%, #FF6B35 100%);
  color: white;
  border-radius: 50%;
  font-weight: bold;
  font-size: 1.2em;
  flex-shrink: 0;
}

.beneficio-item p {
  color: #5B5B5B;
  font-size: 0.95em;
  line-height: 1.4;
  margin: 0;
  font-weight: 500;
  text-align: center;
}

/* Responsive */
@media (max-width: 1024px) {
  .beneficios-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 20px 15px;
  }
}

@media (max-width: 768px) {
  .beneficios-section {
    padding: 30px 20px;
    margin-top: 30px;
  }

  .beneficios-titulo {
    font-size: 1.8em;
    margin-bottom: 20px;
  }

  .beneficios-grid {
    grid-template-columns: 1fr;
    gap: 15px;
  }

  .intro-text {
    margin-bottom: 40px;
  }

  .intro-text p {
    font-size: 1em;
    text-align: left;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Valores.css"],"names":[],"mappings":"AAAA;EACE,6DAA6D;AAC/D;;AAEA;EACE,SAAS;AACX;;AAEA,wBAAwB;AACxB;EACE,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,8BAA8B;EAC9B,oDAAoD;EACpD,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,OAAO;EACP,WAAW;EACX,YAAY;EACZ,iFAAiF;EACjF,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,0BAA0B;EAC1B,wCAAwC;EACxC,8CAA8C;AAChD;;AAEA;EACE,MAAM;AACR;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,sCAAsC;EACtC,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA,uCAAuC;AACvC;EACE,gBAAgB;EAChB,kBAAkB;EAClB,6DAA6D;EAC7D,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,sCAAsC;EACtC,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,6DAA6D;EAC7D,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,eAAe;AACf;EACE;IACE,qCAAqC;IACrC,cAAc;EAChB;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;AACF","sourcesContent":[".valores {\r\n  background: linear-gradient(135deg, #f8f9fa 0%, #fff5f0 100%);\r\n}\r\n\r\n.valores-grid {\r\n  gap: 50px;\r\n}\r\n\r\n/* Texto introductorio */\r\n.intro-text {\r\n  margin-bottom: 60px;\r\n  max-width: 900px;\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n}\r\n\r\n.intro-text p {\r\n  font-size: 1.05em;\r\n  color: #555;\r\n  line-height: 1.9;\r\n  margin-bottom: 20px;\r\n  text-align: justify;\r\n}\r\n\r\n.intro-text p:last-child {\r\n  margin-bottom: 0;\r\n}\r\n\r\n.valor-card {\r\n  position: relative;\r\n  overflow: hidden;\r\n  border-left: 6px solid #FF8C00;\r\n  transition: all 0.5s cubic-bezier(0.23, 1, 0.320, 1);\r\n  border-radius: 15px;\r\n}\r\n\r\n.valor-card::before {\r\n  content: '';\r\n  position: absolute;\r\n  top: -100%;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  background: linear-gradient(180deg, rgba(255, 140, 0, 0.08) 0%, transparent 100%);\r\n  transition: top 0.6s ease;\r\n  z-index: 0;\r\n}\r\n\r\n.valor-card:hover {\r\n  border-left-color: #5B4B8A;\r\n  transform: translateY(-20px) scale(1.04);\r\n  box-shadow: 0 35px 70px rgba(91, 75, 138, 0.2);\r\n}\r\n\r\n.valor-card:hover::before {\r\n  top: 0;\r\n}\r\n\r\n.card-icon {\r\n  font-size: 3em;\r\n  margin-bottom: 15px;\r\n}\r\n\r\n.valor-card h3 {\r\n  position: relative;\r\n  z-index: 1;\r\n  font-size: 1.8em;\r\n  color: #FF8C00;\r\n  margin: 20px 0 15px 0;\r\n  font-family: 'Playfair Display', serif;\r\n  font-weight: 800;\r\n  letter-spacing: 0.3px;\r\n}\r\n\r\n.valor-card p {\r\n  position: relative;\r\n  z-index: 1;\r\n  color: #555;\r\n  line-height: 1.9;\r\n  font-size: 1em;\r\n}\r\n\r\n/* Sección: ¿Qué logras con nosotros? */\r\n.beneficios-section {\r\n  margin-top: 40px;\r\n  padding: 35px 30px;\r\n  background: linear-gradient(135deg, #FFF5E6 0%, #FFE8D6 100%);\r\n  border-radius: 20px;\r\n}\r\n\r\n.beneficios-titulo {\r\n  text-align: center;\r\n  font-size: 1.8em;\r\n  color: #333;\r\n  margin-bottom: 30px;\r\n  font-family: 'Playfair Display', serif;\r\n  font-weight: 800;\r\n  letter-spacing: 0.4px;\r\n}\r\n\r\n.beneficios-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(3, 1fr);\r\n  gap: 25px 20px;\r\n}\r\n\r\n.beneficio-item {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  text-align: center;\r\n  gap: 10px;\r\n  padding: 0;\r\n  background: transparent;\r\n  border-radius: 0;\r\n  box-shadow: none;\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.beneficio-item:hover {\r\n  transform: none;\r\n  box-shadow: none;\r\n}\r\n\r\n.beneficio-icon {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 36px;\r\n  height: 36px;\r\n  background: linear-gradient(135deg, #FF8C00 0%, #FF6B35 100%);\r\n  color: white;\r\n  border-radius: 50%;\r\n  font-weight: bold;\r\n  font-size: 1.2em;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.beneficio-item p {\r\n  color: #5B5B5B;\r\n  font-size: 0.95em;\r\n  line-height: 1.4;\r\n  margin: 0;\r\n  font-weight: 500;\r\n  text-align: center;\r\n}\r\n\r\n/* Responsive */\r\n@media (max-width: 1024px) {\r\n  .beneficios-grid {\r\n    grid-template-columns: repeat(2, 1fr);\r\n    gap: 20px 15px;\r\n  }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .beneficios-section {\r\n    padding: 30px 20px;\r\n    margin-top: 30px;\r\n  }\r\n\r\n  .beneficios-titulo {\r\n    font-size: 1.8em;\r\n    margin-bottom: 20px;\r\n  }\r\n\r\n  .beneficios-grid {\r\n    grid-template-columns: 1fr;\r\n    gap: 15px;\r\n  }\r\n\r\n  .intro-text {\r\n    margin-bottom: 40px;\r\n  }\r\n\r\n  .intro-text p {\r\n    font-size: 1em;\r\n    text-align: left;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
